import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCloudUploadAlt, faPlusCircle, faTrashCan, faLock, faSave, faPencil, faArrowLeft, faCancel, faCog } from '@fortawesome/free-solid-svg-icons';
import './my-settings.css';
import { CustomOptionsDropdown } from './dropdown';
import { CustomTimePicker } from './timePicker';
import { WorkViewDropdown } from './workViewDropdown';
import { SelectionEvents, OptionOnSelectData, useId, Button, DrawerBody, DrawerHeader, DrawerHeaderTitle, OverlayDrawer } from '@fluentui/react-components';
import { Checked } from './checkbox';
import './timePicker.css';
import { Image } from "@fluentui/react-components";
import type { DropdownProps, MenuProps } from "@fluentui/react-components";
import { CommonInfo } from '../../CommonData/Config'
import { Dismiss24Regular } from "@fluentui/react-icons";
import {
    Dropdown,
    makeStyles,
    Option,
    shorthands,
    Avatar,
    Menu,
    MenuTrigger,
    MenuList,
    MenuItem,
    MenuPopover,

} from "@fluentui/react-components";
import Toastr from '../toaster/toaster';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { DeleteAction } from '../dialogues/dialogue-delete';
import GetSettingsService from '../../APIService/mySettingsService';
import Sidenav from './sidebar';
import { useNavigate, useParams } from 'react-router-dom';
import ToastrService from '../toaster/ToastrService';
import { getSettings } from '../../viewmodel/getsettings';
import { useForm } from 'react-hook-form';
import LoginService from '../../APIService/loginservice';
import Swal from 'sweetalert2';
import {useTranslation} from 'react-i18next'

const Commondata = CommonInfo;
const getSettingsData = getSettings;

export const Dateformat = (props: Partial<DropdownProps>) => {
    const dropdownId = useId("dropdown-default");
    const options = Commondata.DateFormat
    return (
        <Dropdown
            aria-labelledby={dropdownId}
            {...props}
            className='drop-down'

        >
            {options.map((option) => (
                <Option key={option} >
                    {option}
                </Option>
            ))}
        </Dropdown>

    );
};
export const Timeformat = (props: Partial<DropdownProps>) => {
    const dropdownId = useId("dropdown-default");
    const options = Commondata.TimeFormat

    return (
        <Dropdown
            aria-labelledby={dropdownId}
            {...props}
            className='drop-down'
        >
            {options.map((option) => (
                <Option key={option.key} value={option.key}>
                    {option.value}
                </Option>
            ))}
        </Dropdown>

    );
};
export const WeekDropdown = (props: Partial<DropdownProps>) => {
    const dropdownId = useId("dropdown-default");
    const options = Commondata.Weekdays;

    return (
        <Dropdown
            aria-labelledby={dropdownId}
            {...props}
            className='drop-down'
        >
            {options.map((option) => (
                <Option key={option} >
                    {option}
                </Option>
            ))}
        </Dropdown>

    );
};


export const Countrydropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];

    return (
        <div >
            <Dropdown
                aria-labelledby={comboId}
                multiselect={true}
                className='drop-down'
                {...props}
            >
                {options.map((option) => (
                    <Option
                        key={option}
                        value={option}
                    >
                        {option}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};

export const Citydropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];

    return (
        <div >
            <Dropdown
                aria-labelledby={comboId}
                multiselect={true}
                className='drop-down'
                {...props}
            >
                {options.map((option) => (
                    <Option
                        key={option}
                        value={option}
                    >
                        {option}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};
export const Sitedropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];

    return (
        <div >
            <Dropdown
                aria-labelledby={comboId}
                multiselect={true}
                className='drop-down'
                {...props}
            >
                {options.map((option) => (
                    <Option
                        key={option}
                        value={option}
                    >
                        {option}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};
export const Buildingdropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];

    return (
        <div >
            <Dropdown
                aria-labelledby={comboId}
                multiselect={true}
                className='drop-down'
                {...props}
            >
                {options.map((option) => (
                    <Option
                        key={option}
                        value={option}
                    >
                        {option}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};
export const Floordropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];

    return (
        <div >
            <Dropdown
                aria-labelledby={comboId}
                multiselect={true}
                className='drop-down'
                {...props}
            >
                {options.map((option) => (
                    <Option
                        key={option}
                        value={option}
                    >
                        {option}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};
export const Zonedropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];

    return (
        <div >
            <Dropdown
                aria-labelledby={comboId}
                multiselect={true}
                className='drop-down'
                {...props}
            >
                {options.map((option) => (
                    <Option
                        key={option}
                        value={option}
                    >
                        {option}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
};
const MySettings: React.FC = () => {
    const {t} = useTranslation();
    const [photo, setPhoto] = useState<File | null>(null);
    const [base64String, setBase64String] = useState<string>("");
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [telephone, setTelephone] = useState('');
    const [result, setResult] = useState(getSettingsData.data.d);
    const [hourtimeformat, setTimeFormat] = useState('');
    const [dateFormat, setDateFormat] = useState('');
    const [dayOfWeek, setFirstDay] = useState(getSettingsData.data?.FirstDayOfWeek);
    const [timeformat, setTime] = useState('');
    let is24HrFormat = getSettingsData.data && getSettingsData.data['Is24HrFormat'];
    const [selectedOptions, setSelectedOptions] = React.useState<string[]>([]);
    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        clearErrors,
        reset,
        formState: { errors, isValid, isDirty },
        control: { _formValues }
    } = useForm();
    const navigate = useNavigate();
    const userIdString = localStorage.getItem('userId'); // userIdString is of type string | null
    let userId: any;
    if (userIdString !== null) {
        userId = parseInt(userIdString); // Parse the value as an integer
    } else {
    }
    const userEmail = localStorage.getItem('userEmail');

    let { id }: any = useParams();
    console.log("id", id);

    const logOut = async () => {
        Swal.fire({
            title: t('LogoutConfirmation'),
            text: t('AreYouSureYouWantToLogout?'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t('No'),
            confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
            cancelButtonColor: localStorage.getItem('Theme') === 'dark' ? "rgba(238, 238, 238, 0.20)" : "#bcc6d0;",
            customClass: {
                popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
            },
            confirmButtonText: t("Yes")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const LogOut = await LoginService.logout();
                if (LogOut.data.ErrCode === '') {
                    localStorage.setItem('loggedIn', 'false');
                    navigate('/login');
                }
            }
        });

    }
    const firstLetterFirstName = _formValues.FirstName ? _formValues.FirstName.charAt(0) : '';
    const firstLetterLastName = _formValues.LastName ? _formValues.LastName.charAt(0) : '';
    const [workInformation, setworkInformation] = useState('');
    const fileInputRef = useRef<HTMLInputElement>(null); // Reference to the file input element
    const [phone, setPhone] = useState("");
    const [checkedDays, setCheckedDays] = useState(Array(7).fill(true));
    const WeekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const deleteMessage1 = t('YouAboutToDeleteTheDataRelatedTo');
    const deleteMessage2 = t("ThisWillAlsoDeleteAllAssociatedDailyDataIncludingTheWorkplacePageAndSoForth")
    const deleteLabel = t("YesDeleteTheDataRelatedTo");
    const [dirty, setIsDirty] = useState(false);
    const save = async () => {
        let keyOfDay;
        for (const [key, value] of Object.entries(Commondata.dateFormatCompare)) {
            if (value === dateFormat) {
                keyOfDay = key;
                break;
            }
        }
        const updatedLocations = await updateWorkLocations();
        if (checkWorkLocationsFilled() && areFormValuesFilled(_formValues)) {
            try {
                console.log(base64String, "base64String");
                const data = {
                    Id: userId,
                    EmailAddress: _formValues.EmailAddress,
                    FirstName: _formValues.FirstName,
                    LastName: _formValues.LastName,
                    TelNumber: '+' + phone + _formValues.TelNumber,
                    UserImage: base64String ? base64String : getSettingsData.data.UserImage.Value,
                    DefaultLocation: getSettingsData.data.DefaultLocation,
                    WorkingDays: getSettingsData.data.WorkingDays,
                    DefaultWorkPlaces: updatedLocations,
                    WorkPlaceVisibility: getSettingsData.data.WorkPlaceVisibility,
                    DateFormat: keyOfDay,
                    Is24hrFormat: timeformat === '24 hour' ? true : false,
                    FirstDayOfWeek: dayOfWeek,
                    Departments: getSettingsData.data.Departments,
                    Teams: getSettingsData.data.Teams,
                    BookableLocations: getSettingsData.data.BookableLocations,
                    ViewableLocations: getSettingsData.data.ViewableLocations,
                    JobTitle: getSettingsData.data.JobTitle
                };
                const getDataResult = await GetSettingsService.SetSettings(data);
                if (getDataResult.data && getDataResult.data?.Updated) {
                    reset()
                    setIsDirty(false);
                    isInitialRender.current = true;
                    CommonInfo.workingDays = getSettingsData.data.WorkingDays
                    localStorage.setItem('Workingdays', JSON.stringify(getSettingsData.data.WorkingDays));
                    ToastrService.success(t('YourSettingsHaveBeenSaved'));
                    localStorage.setItem('Firstdayofweek', dayOfWeek);

                    id = '0'
                    getMySettings();
                } else {
                    ToastrService.error(getDataResult.data?.ErrDesc);
                }
            } catch (error) {
                ToastrService.error(t('AnErrorOccurredWhileSavingYourSettings'));

            }
        }
        else {

        }

    };

    const areFormValuesFilled = (formValues: any) => {
        const requiredFields = [
            'FirstName',
            'LastName',
            'EmailAddress',
            'TelNumber',
            'WorkPlaceVisibility',
            'DateFormat',
            'timeformat',
            'FirstDayOfWeek'
        ];

        return requiredFields.every(field => formValues[field]);
    };


    const checkWorkLocationsFilled = () => {
        let isFilled = true;
        for (const day in workLocations) {
            if (workLocations.hasOwnProperty(day)) {
                const dayWorkLocations = workLocations[day];
                for (const item of dayWorkLocations) {
                    if (!item.StartTime || !item.EndTime || !item.Place) {
                        isFilled = false;
                        break;
                    }
                }
                if (!isFilled) {
                    break;
                }
            }
        }
        if (!isFilled) {
            ToastrService.error(t('PleaseFillInAllFieldsInDefaultWorkLocations'));
        }
        // if (_formValues && isValid) {
        //     return true;
        // } else {
        //     ToastrService.error("");
        // }
        return isFilled;
    };


    const updateWorkLocations = () => {
        const updatedWorkLocations = { ...workLocations };
        for (const day in updatedWorkLocations) {
            if (updatedWorkLocations.hasOwnProperty(day)) {
                const updatedTimes = updatedWorkLocations[day].map((item) => ({
                    ...item,
                    StartTime: convertToTimeString(item.StartTime),
                    EndTime: convertToTimeString(item.EndTime)
                }));
                updatedWorkLocations[day] = updatedTimes;
            }
        }
        return updatedWorkLocations;

    };

    const convertToTimeString = (timeString: string) => {
        const [timePart, period] = timeString.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (period && period.toUpperCase() === 'PM') {
            hours = hours === 12 ? 12 : hours + 12;
        } else if (period && period.toUpperCase() === 'AM') {
            hours = hours === 12 ? 0 : hours;
        }

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedHours = date.getHours().toString().padStart(2, '0');
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes}`;
    };



    const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            let extension
            extension = file.name.split('.').pop()?.toLowerCase();
            const validExtensions = ['png', 'jpg', 'jpeg', 'heic'];

            if (extension && validExtensions.includes(extension)) {
                setPhoto(file);
                const reader = new FileReader();

                reader.onload = (event) => {
                    if (event.target) {
                        let base64Strings = event.target.result as string;
                        // Ensure the correct prefix is included in the base64 string
                        const mimeType = file.type; // Get the correct MIME type from the file
                        if (mimeType) {
                            base64Strings = base64Strings.replace(`^data:${mimeType};base64,`, '');
                        }
                        setBase64String(base64Strings);

                    }
                };


                // Read the file as Data URL, which returns base64 representation
                reader.readAsDataURL(file);
            } else {
                ToastrService.warning(t('PleaseUploadPNGOrJPEGOrHEICImageFile'));
            }
        }

    };

    const handleDivClick = () => {
        // Click the hidden file input element
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };



    useEffect(() => {
        const initialWorkLocations = getSettingsData.data?.DefaultWorkPlaces;
        setWorkLocations(initialWorkLocations);
        getMySettings();
    }, []);

    const getMySettings = async () => {
        try {
            const getDataResult = await GetSettingsService.getMySettings(userId, userEmail);
            if (getDataResult.data.d) {
                getSettingsData.data = getDataResult.data.d;
                is24HrFormat = getSettingsData.data && getSettingsData.data['Is24HrFormat'];
                localStorage.setItem('DateFormat', getDataResult.data.d.DateFormat)
                setResult(getDataResult.data.d);
                getArray();
                const phoneUtil = require('libphonenumbers').PhoneNumberUtil.getInstance();
                const number = phoneUtil.parseAndKeepRawInput(getSettingsData.data.TelNumber.Value);
                setPhone(number?.values_['1'].toString());
                getSettingsData.data['TelNumber'].Value = number?.values_['2'].toString();
                setDatavalue('TelNumber');
            }
        } catch (error) {
        }
    };

    const GetMySettingsBasic = async () => {
        try {
            const getResult = await GetSettingsService.GetSettingsBasic(userId, userEmail);
            if (getResult.data.d) {
                getSettingsData.MysettingsBasicdata = getResult.data.d;
                GetWorkPlacesList()
            }
        } catch (error) {

        }
    }


    const GetWorkPlacesList = async () => {
        try {

            const data =
            {
                "UserId": userId,
                "EmailAddress": userEmail,
                "LocationId": getSettingsData.data.DefaultLocation?.LocationId ? getSettingsData.data.DefaultLocation?.LocationId : null
            }
            console.log(getSettingsData.data.DefaultLocation?.LocationId, "getSettingsData.data.DefaultLocation.LocationId");

            // {
            //     "UserId": 1508,
            //     "EmailAddress": "vijay.manickam@qedas.com",
            //     "LocationId": 98
            // }
            const getResult = await GetSettingsService.GetWorkPlacesList(data);
            if (getResult.data.d) {
                getSettingsData.workPlacelist = getResult.data.d.WorkPlaces;
                if (getSettingsData.workPlacelist.length <= 0) {
                    getSettingsData.workPlacelist = [
                        {
                            Id: 0,
                            Name: t('NoDataAvailable'),
                            IconPath: "",
                            LocationId: 0
                        }
                    ]

                }

            }
        } catch (error) {

        }
    }
    const isInitialRender = useRef(true);


    const setvalue = async () => {
        setData('FirstName');
        setData('LastName');
        setDatavalue('EmailAddress');
        setData('WorkPlaceVisibility');
        setData('FirstDayOfWeek');
        setFirstDay(getSettingsData.data.FirstDayOfWeek)
        if (is24HrFormat) {
            setTime('24 hour');
            setValue('timeformat', '24 hour');

        } else {
            setTime('12 hour');
            setValue('timeformat', '12 hour');


        }
        const date: string = getSettingsData.data?.DateFormat;
        const data = Commondata.dateFormatCompare[date as keyof typeof Commondata.dateFormatCompare];
        setDateFormat(data)
        setValue('DateFormat', data)
        _formValues.DateFormat = data;
        workInformationselct({ optionValue: getSettingsData.data?.WorkPlaceVisibility })
    }
    const setData = (controllerName: string) => {
        const userDetails = getSettingsData.data;
        if (userDetails && userDetails[controllerName]) {
            setValue(controllerName, userDetails[controllerName]);
        }
    };

    const setDatavalue = (controllerName: string) => {
        const userDetails = getSettingsData.data;
        if (userDetails && userDetails[controllerName]) {
            setValue(controllerName, userDetails[controllerName].Value);
        }
    }

    const dayMapping: { [key: string]: string } = {
        'Sun': 'Sunday',
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday'
    };
    const [Workplaces, SetWorkplaces] = useState(false)

    const moment = require('moment');
    const defaultWorkPlace = is24HrFormat ? [{ StartTime: "9:00", EndTime: "17:00", Place: "Office" }] : [{ StartTime: "9:00 AM", EndTime: "5:00 PM ", Place: "Office" }];


    const getArray = async () => {
        setvalue();
        await trigger('timeformat') // Update form value with selected data
        const initialWorkLocations = getSettingsData.data.DefaultWorkPlaces;
        Object.keys(initialWorkLocations).forEach((day) => {
            const schedules = initialWorkLocations[day];
            if (schedules.length > 0) {
                // const schedule = schedules[0];
                getSettingsData.data.DefaultWorkPlaces[day].forEach((v: any) => {
                    v.StartTime = formatDateToTimeString(moment(v.StartTime, 'HH:mm').toDate());
                    v.EndTime = formatDateToTimeString(moment(v.EndTime, 'HH:mm').toDate());
                });
            }
        });

        const orderedDays = Object.values(dayMapping);
        const workingDays = getSettingsData.data.WorkingDays || {}
        if (!getSettingsData.data.WorkingDays) {
            setCheckedDays(Object.values(false))
        }
        orderedDays.forEach((day, index) => {
            if (day !== Object.keys(workingDays)[index]) {
                let temp = workingDays[day];
                delete workingDays[day];
                workingDays[day] = temp;
                // let keyOfDay;
                // for (const [key, value] of Object.entries(dayMapping)) {
                //     if (value === day) {
                //         keyOfDay = key;
                //         break; // Exit loop once we find the key
                //     }
                // }
                // handleCheckboxChange(index, keyOfDay ? keyOfDay : '');
            }
        });
        setCheckedDays(Object.values(workingDays));
        const filteredDefaultWorkPlaces = Object.keys(initialWorkLocations).reduce((acc: any, day: any) => {
            acc[day] = workingDays[day] ? initialWorkLocations[day].sort(compareTimes) : [];
            return acc;
        }, {});

        const hasWorkingDays = Object.values(workingDays).includes(true);
        const allDaysEmpty = Object.keys(filteredDefaultWorkPlaces).every(day => filteredDefaultWorkPlaces[day].length === 0);
        let show = false;
        if ((hasWorkingDays && allDaysEmpty) || !hasWorkingDays) {
            SetWorkplaces(true);
            show = true;

        }
        if (id == '1' && show) {
            Swal.fire({
                title: t('DefaultWorkLocations'),
                text: t('YourDefaultWorkLocationsHaveBeenAutomaticallyConfiguredPleaseVerifyAndSave'),
                icon: "info",
                confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
                customClass: {
                    popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
                },
                confirmButtonText: t('Ok')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    if (!hasWorkingDays) {
                        const allCheckedDays = orderedDays.reduce((acc: any, day: any) => {
                            if (day !== 'Saturday' && day !== 'Sunday') {
                                acc.push(true);
                                filteredDefaultWorkPlaces[day] = defaultWorkPlace;
                                getSettingsData.data.WorkingDays[day] = true;
                                show = false;

                            } else {
                                acc.push(false);
                            }
                            return acc;
                        }, []);
                        setCheckedDays(allCheckedDays);
                    }

                    Object.keys(workingDays).forEach(day => {
                        if (workingDays[day]) {
                            filteredDefaultWorkPlaces[day] = defaultWorkPlace;
                        }
                    });
                    setWorkLocations(filteredDefaultWorkPlaces);
                    SetWorkplaces(false);
                }
            });
        } else {
            setWorkLocations(filteredDefaultWorkPlaces);
        }

        GetMySettingsBasic()

    };

    const GenerateWorkPlace = () => {
        const initialWorkLocations = getSettingsData.data.DefaultWorkPlaces;
        const workingDays = getSettingsData.data.WorkingDays || {};

        // Format the StartTime and EndTime
        Object.keys(initialWorkLocations).forEach((day) => {
            const schedules = initialWorkLocations[day];
            if (schedules.length > 0) {
                getSettingsData.data.DefaultWorkPlaces[day].forEach((v: any) => {
                    v.StartTime = formatDateToTimeString(moment(v.StartTime, 'HH:mm').toDate());
                    v.EndTime = formatDateToTimeString(moment(v.EndTime, 'HH:mm').toDate());
                });
            }
        });

        const hasWorkingDays = Object.values(workingDays).includes(true);
        const orderedDays = Object.values(dayMapping);
        const filteredDefaultWorkPlaces = Object.keys(initialWorkLocations).reduce((acc: any, day: any) => {
            acc[day] = workingDays[day] ? initialWorkLocations[day].sort(compareTimes) : [];
            return acc;
        }, {});

        // If no working days are present, check all checkboxes and set default work places
        if (!hasWorkingDays) {
            const allCheckedDays = orderedDays.reduce((acc: any, day: any) => {
                if (day !== 'Saturday' && day !== 'Sunday') {
                    acc.push(true);
                    getSettingsData.data.WorkingDays[day] = true;
                    filteredDefaultWorkPlaces[day] = defaultWorkPlace;
                } else {
                    acc.push(false);
                }
                return acc;
            }, []);
            setCheckedDays(allCheckedDays);
        }
        Object.keys(workingDays).forEach(day => {
            if (workingDays[day]) {
                filteredDefaultWorkPlaces[day] = defaultWorkPlace;
            }
        });
        setWorkLocations(filteredDefaultWorkPlaces);
        SetWorkplaces(false);
    }

    const compareTimes = (a: any, b: any) => {
        const parseTime = (timeStr: any) => {
            const [time, modifier] = timeStr.split(' ');
            let [hours, minutes] = time.split(':').map(Number);
            if (modifier === 'PM' && hours < 12) hours += 12;
            if (modifier === 'AM' && hours === 12) hours = 0;
            return { hours, minutes };
        };

        const startA = parseTime(a.StartTime);
        const startB = parseTime(b.StartTime);
        if (startA.hours !== startB.hours) {
            return startA.hours - startB.hours;
        }
        return startA.minutes - startB.minutes;
    };

    const [workLocations, setWorkLocations] = useState<{ [key: string]: { StartTime: string; EndTime: string; Place: string }[] }>(
        WeekDays.reduce((acc, day) => ({ ...acc, [day]: [] }), {})
    );

    const handleCheckboxChange = (index: number, dayShort: string) => {
        const updatedWorkLocations = { ...workLocations };
        const newCheckedDays = [...checkedDays];
        newCheckedDays[index] = !newCheckedDays[index];
        setCheckedDays(newCheckedDays);
        const fullDayName = dayMapping[dayShort];
        for (const [key, value] of Object.entries(getSettingsData.data?.WorkingDays)) {
            if (key === fullDayName) {
                getSettingsData.data.WorkingDays[fullDayName] = !value;
                break;
            }
        }
        if (newCheckedDays[index]) {
            if (updatedWorkLocations.hasOwnProperty(fullDayName)) {
                if (is24HrFormat) {
                    updatedWorkLocations[fullDayName] = [{ StartTime: "9:00", EndTime: "17:00 ", Place: "Office" }];
                }
                else {
                    updatedWorkLocations[fullDayName] = [{ StartTime: "9:00 AM", EndTime: "5:00 PM ", Place: "Office" }];

                }
            }
        } else {
            if (updatedWorkLocations.hasOwnProperty(fullDayName)) {
                updatedWorkLocations[fullDayName] = updatedWorkLocations[fullDayName].filter(() => {
                    return false;
                });
            }
        }
        setWorkLocations(updatedWorkLocations);
        setIsDirty(true);
    };

    const handleDropdownChange = (day: string, index: number, Place: any) => {
        setWorkLocations(prevLocations => ({
            ...prevLocations,
            [day]: prevLocations[day].map((loc, i) => (i === index ? { ...loc, Place } : loc))
        }));
        setIsDirty(true);
    };

    const locationChange = (event: React.SyntheticEvent, data: { optionValue: string }) => {
        let newSelectedOptions;
        if (selectedOptions.includes(data.optionValue)) {
            newSelectedOptions = selectedOptions.filter(opt => opt !== data.optionValue);
        } else {
            newSelectedOptions = [data.optionValue];
        }

        if (newSelectedOptions.length > 1) {
            setSelectedOptions([]);
        } else {
            setSelectedOptions(newSelectedOptions);
        }
    };


    const parseTime = (timeStr: any) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);

        if (modifier === 'PM' && hours !== 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    };

    const handleAddWorkLocation = async (day: any, locations: any[], use24HourFormat: boolean) => {
        const latestEndTime = locations.reduce((latest, location) => {
            const { hours, minutes } = parseTime(location.EndTime);
            const totalMinutes = hours * 60 + minutes;

            return totalMinutes > latest ? totalMinutes : latest;
        }, 0);

        const endHours = Math.floor(latestEndTime / 60);
        const endMinutes = Math.ceil((latestEndTime % 60) / 30) * 30; // Round up to the nearest 30 minutes

        let endHourString;
        let endMinuteString;
        let period = ''; // Empty string for 24-hour format

        if (use24HourFormat) {
            endHourString = endHours.toString().padStart(2, '0');
            endMinuteString = endMinutes.toString().padStart(2, '0');
        } else {
            // Determine AM/PM for the latest end time
            period = endHours >= 12 ? 'PM' : 'AM';
            endHourString = (endHours % 12 || 12).toString();
            endMinuteString = endMinutes.toString().padStart(2, '0');
        }

        const endTimeString = use24HourFormat
            ? `${endHourString}:${endMinuteString}`
            : `${endHourString}:${endMinuteString} ${period}`;

        // Use only one format for comparison to avoid ambiguity
        const endTime24HourString = `${endHours.toString().padStart(2, '0')}:${endMinuteString}`;
        const newStartTime = endTimeString;
        const newEndTime = endTime24HourString >= '17:30' ? '' : (use24HourFormat ? '17:30' : '5:30 PM');

        await setWorkLocations(prevLocations => ({
            ...prevLocations,
            [day]: [...prevLocations[day], { StartTime: newStartTime, EndTime: newEndTime, Place: 'Office' }]
        }));
        setIsDirty(true);
    };

    const handleDeleteWorkLocation = (day: string, index: number) => {
        setWorkLocations(prevLocations => ({
            ...prevLocations,
            [day]: prevLocations[day].filter((_, i) => i !== index)
        }));
        setIsDirty(true);
    };

    const workInformationselct = async (selectedoption: any) => {
        if (getSettingsData.data) {
            getSettingsData.data.WorkPlaceVisibility = selectedoption.optionValue;
            setValue('WorkPlaceVisibility', selectedoption.optionValue); // Update form value with selected data
        }
        if (isInitialRender.current) {
            // Skip the initial render logic
            setIsDirty(false);
            isInitialRender.current = false;
        }
        else {
            setIsDirty(true);
            // return;
        }

        switch (selectedoption.optionValue) {
            case t('Department'):
                setworkInformation(t('OnlyAdministratorsOrMembersYourTeamsOrDepartmentCanViewWorkLocationSchedule'))
                return;
            case t('Organisation'):
                setworkInformation(t('AnyMemberYourOrganisationViewYourWorkLocationSchedule'))
                return;
            case t('Team'):
                setworkInformation(t('OnlyAdministratorsAndMembersYourTeamsViewWorkLocationSchedule'))
                return;
            case t('OnlyMe'):
                setworkInformation(t('OnlyAdministratorsAndYourTeamLeadersAbleToViewWorkLocationSchedule'))
                return;
            default:
                setworkInformation(t('OnlyAdministratorsOrMembersYourTeamsOrDepartmentCanViewWorkLocationSchedule'))
                return;
        }
    };
    const [isOpen, setIsOpen] = React.useState(false);
    const DateformatSelect = async (data: any) => {
        // let keyOfDay;
        // for (const [key, value] of Object.entries(dayMapping)) {
        //     if (value === data.optionText) {
        //         keyOfDay = key;
        //         break;
        //     }
        // }
        setIsDirty(true);
        setValue('DateFormat', data.optionText); // Update form value with selected data
        await trigger('DateFormat');
        setDateFormat(data.optionText)
    }

    const TimeformatSelect = async (timeformat: any) => {
        setValue('timeformat', timeformat.optionText); // Update form value with selected data
        await trigger('timeformat')
        setIsDirty(true);
        setTime(timeformat.optionText)
    }


    const DaySelect = async (day: any) => {
        setFirstDay(day.optionText)
        getSettingsData.data['FirstDayOfWeek'] = day.optionText;
        setValue('FirstDayOfWeek', day.optionText);
        setIsDirty(true); // Update form value with selected data
        await trigger('FirstDayOfWeek')
    }


    function hoverHandler() {
        var inputBox = theme === 'dark' ? document.querySelector('.inputBox_Darker.boxes.codes') : document.querySelector('.inputBox.boxes.codes');
        var formControl = theme === 'dark' ? document.querySelector('.react-tel-input .form-control') : document.querySelector('.react-tel-input .form-control');
        if (inputBox !== null && formControl !== null) {
            inputBox.classList.toggle('hovered');
            formControl.classList.toggle('hovered');
        }
    }

    function clearClass() {
        var inputBox = theme === 'dark' ? document.querySelector('.inputBox_Darker.boxes.codes') : document.querySelector('.inputBox.boxes.codes');
        var formControl = theme === 'dark' ? document.querySelector('.react-tel-input .form-control') : document.querySelector('.react-tel-input .form-control');
        if (inputBox && formControl) {
            inputBox.classList.remove('hovered');
            formControl.classList.remove('hovered');
        }
    }

    const formatDateToTimeString = (date: any) => {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

        return is24HrFormat ? `${hours}:${formattedMinutes}` : timeString;
    };

    const handleTimeChange = (day: string, index: number, type: 'StartTime' | 'EndTime', time: any) => {
        if (time.selectedTime !== null) {
            const formattedTime = formatDateToTimeString(time.selectedTime); // Use the formatting function
            const newTime = formattedTime;
            const existingStartTimes = workLocations[day].map(loc => loc.StartTime);
            const existingEndTimes = workLocations[day].map(loc => loc.EndTime);
            const selectedStartTime = is24HrFormat ? moment(existingStartTimes[index], 'HH:mm') : moment(existingStartTimes[index], 'hh:mm A');
            const selectedEndTime = is24HrFormat ? moment(existingEndTimes[index], 'HH:mm') : moment(existingEndTimes[index], 'hh:mm A');
            const newselectedTime = is24HrFormat ? moment(newTime, 'HH:mm') : moment(newTime, 'hh:mm A');

            const isStartDuplicate = existingStartTimes.some((startTime, i) => i !== index && startTime === formattedTime);
            const isEndDuplicate = existingEndTimes.some((endTime, i) => i !== index && endTime === formattedTime);

            if (type === 'StartTime' && isStartDuplicate) {
                ToastrService.warning(t('TheSameStartTimeForTheSameDayHasAlreadyBeenSelected'));
                return;
            }

            if (type === 'EndTime' && isEndDuplicate) {
                ToastrService.warning(t('TheSameStartTimeForTheSameDayHasAlreadyBeenSelected'));
                return;
            }

            if (type === 'StartTime' && selectedStartTime && selectedEndTime && newselectedTime.isAfter(selectedEndTime)) {
                ToastrService.warning(t('StartTimeMustBeEarlierThanTheEndTime'));
                return;
            }

            if (type === 'StartTime' && selectedEndTime && (newselectedTime.isSame(selectedEndTime))) {
                ToastrService.warning(t('StartTimeAndEndTimeCannotBeTheSame'));
                return;
            }

            if (type === 'EndTime' && selectedStartTime && (newselectedTime.isSame(selectedStartTime))) {
                ToastrService.warning(t('StartTimeAndEndTimeCannotBeTheSame'));
                return;
            }

            if (type === 'EndTime' && selectedStartTime && selectedEndTime && newselectedTime.isBefore(selectedStartTime)) {
                ToastrService.warning(t('EndTimeMustBeLaterThanTheStartTime'));
                return;
            }

            let updatedWorkLocations = [...workLocations[day]];

            if (type === 'StartTime') {
                updatedWorkLocations = updatedWorkLocations.map((loc, i) => {
                    if (i !== index) {
                        const existingStartTime = is24HrFormat ? moment(loc.StartTime, 'HH:mm') : moment(loc.StartTime, 'hh:mm A');
                        const existingEndTime = is24HrFormat ? moment(loc.EndTime, 'HH:mm') : moment(loc.EndTime, 'hh:mm A');
                        if (newselectedTime.isBetween(existingStartTime, existingEndTime, null, '[)')) {
                            return {
                                ...loc,
                                EndTime: newselectedTime.format(is24HrFormat ? 'HH:mm' : 'hh:mm A'), // Update format based on is24HrFormat
                            };
                        }
                    }
                    return loc;
                });
            }

            const newStartTime = type === 'StartTime' ? newselectedTime : selectedStartTime;
            const newEndTime = type === 'EndTime' ? newselectedTime : selectedEndTime;

            const isWithinRange = updatedWorkLocations.some((loc, i) => {
                if (i !== index) {
                    const existingStartTime = is24HrFormat ? moment(loc.StartTime, 'HH:mm') : moment(loc.StartTime, 'hh:mm A');
                    const existingEndTime = is24HrFormat ? moment(loc.EndTime, 'HH:mm') : moment(loc.EndTime, 'hh:mm A');

                    return (
                        newStartTime.isBetween(existingStartTime, existingEndTime, null, '[)') ||
                        newEndTime.isBetween(existingStartTime, existingEndTime, null, '(]') ||
                        (newStartTime.isBefore(existingStartTime) && newEndTime.isAfter(existingEndTime))
                    );
                }
                return false;
            });

            if (isWithinRange) {
                ToastrService.warning(t('TheSelectedTimeIsWithinexistingtimeRangeForTheSameDay'));
                return;
            }

            setWorkLocations(prevLocations => ({
                ...prevLocations,
                [day]: updatedWorkLocations.map((loc, i) => (i === index ? { ...loc, [type]: formattedTime } : loc))
            }));
        }
        setIsDirty(true);

    };


    const order = ["Country", "City", "Building", "Floor", "LocationId"];
    const BookableLocations = getSettingsData.data.BookableLocations?.map((location: any) => {
        const formattedString = order
            .filter(key => location[key] !== null && location[key] !== undefined)
            .map(key => `${location[key]}`)
            .join(', ');

        return formattedString;
    })


    const ViewonlyLocations = getSettingsData.data.ViewableLocations?.map((location: any) => {
        const formattedString = order
            .filter(key => location[key] !== null && location[key] !== undefined)
            .map(key => `${location[key]}`)
            .join(', ');

        return formattedString;
    })

    const handleKeyPress = (event: any) => {
        if (!/[0-9]/i.test(event.key)) {
            event.preventDefault();
        }
    }

    const showNameShort = () => {
        if (photo) {
            return false;
        } else if (getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value) {
            return false;
        } else {
            return true;
        }
    };

    const [workplace, setWorkPlace] = useState('')
    const setWork = () => {
        const order = ["Country", "City", "Building", "Floor", "LocationId"];
        const formattedString = order
            .map(key => getSettingsData.data.DefaultLocation[key])
            .filter(value => value !== null)
            .join(', ');
        setWorkPlace(formattedString)

    }

    const theme = localStorage.getItem('Theme')

    const darkModeStyles = {
        inputStyle: {
            backgroundColor: "#1A1A1A",
            color: "#fff",

        },
        buttonStyle: {
        },
        dropdownStyle: {
            backgroundColor: "#1A1A1A",
            color: "#fff",
        }
    };

    const lightModeStyles = {
        inputStyle: {},
        buttonStyle: {},
        dropdownStyle: {}
    };

    const customStyles = theme === "dark" ? darkModeStyles : lightModeStyles;

    const submit = async () => {
        const isFormValid = await trigger();
        if (!isFormValid) {
            ToastrService.error(t('PleaseFillTheRequiredFields'));
            return;
        }
    }

    const goBack = () => {
        if (isDirty || dirty) {
            Swal.fire({
                title: t('Confirmation'),
                text: t('YouHaveUnsavedChangesDoYouReallyWantToLeave'),
                icon: "info",
                showCancelButton: true,
                cancelButtonText: t("Cancel"),
                confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
                cancelButtonColor: localStorage.getItem('Theme') === 'dark' ? "rgba(238, 238, 238, 0.20)" : "#bcc6d0;",
                customClass: {
                    popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
                },
                confirmButtonText: t("Ok")
            }).then(async (result) => {
                if (result.isConfirmed) {
                    navigate('/workplace');
                }
            });
        }
        else {
            navigate('/workplace');

        }

    }

    return (
        <div className={`sidenav-container`}>
            <Sidenav authToken={null} LoguserName={null} />
            <div className={theme === 'dark' ? 'main-content_dark content pt-0' : 'main-content content pt-0'} >
                <form onSubmit={handleSubmit(save, submit)}>
                    <div className={`${theme === 'dark' ? 'position_sticky_dark row  px-4 pt-4 pb-2' : 'position_sticky row  px-4 pt-4 pb-2'}`}>
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6">
                            <label className='head'>{t('MySettings')}</label>&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                        <div className="col-xl-4 col-md-4 col-lg-4 col-sm-6 right ">
                            <button className={theme === 'dark' ? 'bttn_dark' : 'bttn'} ><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;{t('Save')}</button>
                            <button type="button" onClick={goBack} className={theme === 'dark' ? 'bttn_dark' : 'bttn'} ><FontAwesomeIcon icon={faCancel} />&nbsp;&nbsp;{t('Cancel')}</button>
                            <Menu>
                                <MenuTrigger disableButtonEnhancement>
                                    <Avatar
                                        name={localStorage.getItem('UserName')?.toString()}
                                        image={{
                                            src: getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value
                                                ? getSettingsData.data.UserImage.Value
                                                : "",
                                        }}
                                        style={{
                                            cursor: "pointer", width: "45px", height: "43px"
                                        }}
                                        shape="circular"
                                    />
                                </MenuTrigger>
                                <MenuPopover className='mt-2' style={{ width: "14rem" }}>
                                    <MenuList>
                                        {/* <MenuItem style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={Commondata.folderName + "resetpassword.svg"} />&nbsp;&nbsp;Reset password</MenuItem> */}
                                        <MenuItem onClick={logOut} style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Logoutlight.svg' : '/logout.svg'}`} />&nbsp;&nbsp;{t('LogOut')}</MenuItem>
                                    </MenuList>
                                </MenuPopover>
                            </Menu>
                            {ToastrService.getToastrComponent()}
                        </div>
                    </div>
                    <div className="container">
                        <div className="col-md-2">
                        </div>
                        <div className="row mt-5">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <div className='row mb-2'><h5 className={theme === 'dark' ? ' p-0 headers_dark' : 'p-0 headers'}>{t('ProfileImage')}</h5></div>
                                <div className="row">
                                    <div className={theme === 'dark' ? 'pic-back_dark' : 'pic-back'}>
                                        <div className="photo-upload">
                                            <input
                                                type="file"
                                                onChange={handlePhotoChange}
                                                ref={fileInputRef}
                                            />
                                        </div>
                                        <div className="photo-upload d-flex">
                                            <div className='cloud-icon' onClick={handleDivClick}>
                                                <FontAwesomeIcon icon={faCloudUploadAlt} className="font-icon" style={{ fontSize: '28px' }} />
                                            </div>
                                            {(photo || (getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value))
                                                && <img
                                                    onClick={handleDivClick}
                                                    src={
                                                        photo
                                                            ? URL.createObjectURL(photo)
                                                            : getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value
                                                                ? getSettingsData.data.UserImage.Value
                                                                : ""
                                                    }
                                                    alt="User"
                                                />}
                                            {showNameShort() && (
                                                <label onClick={handleDivClick} className={theme === 'dark' ? 'short_name_dark' : 'short_name'}>
                                                    {firstLetterFirstName}{firstLetterLastName}
                                                </label>
                                            )}


                                            <div className='marg-left'>
                                                <span>{t('ClickHereOrDragAndDrop')} </span><br />
                                                <span>{t('ToChangeImage')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 headers_dark' : 'p-0 headers'}>{t('AboutMe')}</h5></div>
                                <div className="row mb-3 px-1">
                                    <div className="col-md-6">
                                        <label className={theme === 'dark' ? 'label-head_dark mandatory' : 'label-head mandatory'}>{t('FirstName')}</label>
                                        <input
                                            className={theme === 'dark' ? 'inputBox_Dark boxes' : 'inputBox boxes'}
                                            type="text"
                                            {...register('FirstName', {
                                                required: t('TheFirstNameFieldIsRequired'),
                                            })}
                                        // onChange={() => {
                                        //     if (errors.FirstName) {
                                        //         clearErrors('FirstName');
                                        //     }
                                        // }}
                                        />
                                        {errors.FirstName && (
                                            <span className="errorText mt-2 px-2"> {t('TheFirstNameFieldIsRequired')}</span>
                                        )}

                                    </div>
                                    <div className="col-md-6">
                                        <label className={theme === 'dark' ? 'label-head_dark mandatory' : 'label-head mandatory'}>{t('LastName')}</label>
                                        <input className={theme === 'dark' ? 'inputBox_Dark boxes' : "inputBox boxes"} type="text" readOnly={false}  {...register("LastName", {
                                            required: true,
                                        })}
                                        // onChange={() => {
                                        //     if (errors.LastName) {
                                        //         clearErrors('LastName');
                                        //     }
                                        // }}
                                        />
                                        {errors.LastName && errors.LastName.type === "required" && (
                                            <span className="errorText mt-2 px-2"> {t('LastNameFieldIsRequired')}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-3 px-1">
                                    <div className="col-md-12">
                                        <label className={theme === 'dark' ? 'label-head_dark lock-icon mandatory' : 'label-head lock-icon mandatory'}><Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`}
                                        />
                                            <span className='mar-left'>{t('EmailAddress')}</span></label>
                                        <input className={theme === 'dark' ? 'inputBox_Darker locked_dark ' : "inputBox locked"} type="text" readOnly={getSettingsData.data?.EmailAddress?.Locked} style={{ background: "#313131 !important;" }}   {...register("EmailAddress", {
                                            required: true,
                                            pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/

                                        })}
                                        // onChange={() => {
                                        //     if (errors.EmailAddress) {
                                        //         clearErrors('EmailAddress');
                                        //     }
                                        // }} 
                                        />
                                        {errors.EmailAddress && errors.EmailAddress.type === "required" && (
                                            <span className="errorText mt-2 px-2"> {t('EmailAddressFieldIsRequired')}</span>
                                        )}
                                        {errors.EmailAddress && errors.EmailAddress.type === "pattern" && (
                                            <span className="errorText mt-2 px-2">{t('PleaseEnterValidEmailAddress')}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-3 px-1">
                                    <div className="col-md-12">
                                        <label className={theme === 'dark' ? 'label-head_dark mandatory' : 'label-head mandatory'}>{t('TelephoneNo')}</label>
                                        <div className={theme === 'dark' ? 'telephone-input_dark' : "telephone-input"}>
                                            <div className="flag">  <PhoneInput
                                                country={"eg"}
                                                enableSearch={true}
                                                value={phone}
                                                onChange={(phone) => setPhone(phone)}
                                                inputStyle={customStyles.inputStyle}
                                                buttonStyle={customStyles.buttonStyle}
                                                dropdownStyle={customStyles.dropdownStyle}
                                            />
                                            </div>
                                            <input onKeyPress={handleKeyPress} inputMode='numeric' onMouseOver={hoverHandler} onMouseLeave={clearClass} className={theme === 'dark' ? 'inputBox_Darker boxes codes mobile' : "inputBox boxes codes mobile"}
                                                type="text" maxLength={15}   {...register("TelNumber", {
                                                    required: true,
                                                    pattern: /^\d{10}$/
                                                })}
                                            // onChange={() => {
                                            //     if (errors.TelNumber) {
                                            //         clearErrors('TelNumber');
                                            //     }
                                            // }} 
                                            />

                                        </div>
                                        {errors.TelNumber && errors.TelNumber.type === "required" && (
                                            <span className="errorText mt-3 px-2"> {t('TelephoneNumberFieldIsRequired')}</span>
                                        )}
                                        {errors.TelNumber && errors.TelNumber.type === "pattern" && (
                                            <span className="errorText mt-3 px-2">{t('PleaseEnterValidTelephoneNumber')}</span>
                                        )}

                                    </div>
                                </div>
                                <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 headers_dark' : 'p-0 headers'}>{t('WorkingDays')}</h5></div>
                                <div className={theme === 'dark' ? ' row dark_check' : "row"}>
                                    <div className="col-md-12">
                                        <Checked checkedDays={checkedDays} onCheckboxChange={handleCheckboxChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 p-0 headers_dark mandatory' : 'p-0 headers mandatory'}>{t('DefaultWorkLocations')}</h5></div>
                                        {/* <div className="row mb-3 px-1">
                                            <div className="col-md-10 mt-3">
                                                <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon'}>
                                                    <span >Office location</span></label>
                                                <input className="inputBox" type="text" value={workplace} readOnly />
                                            </div>
                                            <div className="col-md-2 mt-5">
                                                <button className='button' type='button' onClick={() => setIsOpen(!isOpen)}><FontAwesomeIcon icon={faPencil} className='icon' />Update</button>
                                            </div>
                                        </div> */}
                                        {/* <OverlayDrawer
                                            modalType="non-modal"
                                            open={isOpen}
                                            onOpenChange={(_, { open }) => setIsOpen(open)}
                                            position={'end'}
                                        >
                                            <DrawerHeader>
                                                <DrawerHeaderTitle>
                                                    <div className='row mb-2 mt-3'>
                                                        <div className="col-11">
                                                            <h5 className=theme ==='dark' ? 'p-0 headers_dark' :'p-0 headers mandatory'>
                                                                Location selection</h5>
                                                        </div>
                                                        <div className="col-1">
                                                            <button type='button' onClick={() => setIsOpen(false)} className='save_btn' ><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Save</button>
                                                        </div>

                                                    </div>
                                                </DrawerHeaderTitle>
                                            </DrawerHeader>

                                            <DrawerBody>
                                                <div className="row mt-3 px-1">
                                                    <div className="col-md-12">
                                                        <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon }mandatory'>
                                                            <span className='mar-left'>Country</span></label>
                                                        <Countrydropdown onOptionSelect={(event, data: any) => locationChange(event, data)}
                                                            selectedOptions={selectedOptions} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 px-1">
                                                    <div className="col-md-12">
                                                        <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon }mandatory'>
                                                            <span className='mar-left'>City</span></label>
                                                        <Citydropdown onOptionSelect={(event, data: any) => locationChange(event, data)}
                                                            selectedOptions={selectedOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 px-1">
                                                    <div className="col-md-12">
                                                        <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon }mandatory'>
                                                            <span className='mar-left'>Site</span></label>
                                                        <Sitedropdown onOptionSelect={(event, data: any) => locationChange(event, data)}
                                                            selectedOptions={selectedOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 px-1">
                                                    <div className="col-md-12">
                                                        <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon }mandatory'>
                                                            <span className='mar-left'>Building</span></label>
                                                        <Buildingdropdown onOptionSelect={(event, data: any) => locationChange(event, data)}
                                                            selectedOptions={selectedOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 px-1">
                                                    <div className="col-md-12">
                                                        <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon }mandatory'>
                                                            <span className='mar-left'>Floor</span></label>
                                                        <Floordropdown onOptionSelect={(event, data: any) => locationChange(event, data)}
                                                            selectedOptions={selectedOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 px-1">
                                                    <div className="col-md-12">
                                                        <label className={theme === 'dark' ? 'label-head_dark' :'label-head lock-icon }mandatory'>
                                                            <span className='mar-left'>Zone</span></label>
                                                        <Zonedropdown onOptionSelect={(event, data: any) => locationChange(event, data)}
                                                            selectedOptions={selectedOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </DrawerBody>
                                        </OverlayDrawer> */}
                                        {Workplaces && (
                                            <div>
                                                <label className={theme === 'dark' ? 'label-head_dark lock-icon' : 'label-head lock-icon'}>
                                                    {t('YourDefaultWorkLocationsAreNotConfiguredPleaseConfigureItNow')}
                                                </label>
                                                <button type="button" onClick={GenerateWorkPlace} className={theme === 'dark' ? 'generate_bttn_dark mt-4' : 'generate_bttn mt-4'} ><FontAwesomeIcon icon={faCog} />&nbsp;&nbsp;{t('Configure')}</button>
                                            </div>
                                        )}
                                        {WeekDays?.map((day: any) => (
                                            <div key={day}>
                                                {workLocations[day] ? workLocations[day]?.map((location: any, index: number) => (
                                                    <div key={index} className="row mb-3 work-location mt-4 ">
                                                        <div className='col-lg-3 col-xl-3 col-md-3 col-sm-2'>
                                                            {index === 0 && <span className='days-full'>{day}</span>}
                                                        </div>
                                                        <div className='col-9' style={{ display: 'flex' }}>
                                                            <div className="col-1"></div>
                                                            <div className={theme === 'dark' ? ' col-11 svg_dark' : 'col-11'} style={{ display: 'flex' }}>
                                                                <div className='col-lg-2 col-xl-2 col-md-4 col-sm-3 p-0'>
                                                                    <CustomTimePicker
                                                                        value={location.StartTime}
                                                                        onTimeChange={(event, data) => handleTimeChange(day, index, 'StartTime', data)} isFormattedTime={is24HrFormat} />
                                                                </div>
                                                                <div className='col-1 text-center'>
                                                                    {t('To')}
                                                                </div>
                                                                <div className='col-lg-2 col-xl-2 col-md-4 col-sm-3 p-0'>
                                                                    <CustomTimePicker value={location.EndTime} isFormattedTime={is24HrFormat} onTimeChange={(event, data) => handleTimeChange(day, index, 'EndTime', data)} />
                                                                </div>
                                                                <div className=' col-lg-6 col-xl-6 col-md-7 col-sm-6 mx-1'>
                                                                    <CustomOptionsDropdown
                                                                        workplaceList={getSettingsData.workPlacelist} value={location.Place}
                                                                        onOptionSelect={(event, data) => handleDropdownChange(day, index, data.optionValue)}
                                                                    />
                                                                </div>
                                                                <div className='col-lg-1 col-xl-1 col-md-1 col-sm-1 plus_icon'>
                                                                    {index === 0 && <Image id="img" className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/plus_circlelight.svg' : '/plus-circle.svg'}`} onClick={() => handleAddWorkLocation(day, workLocations[day], is24HrFormat)} />}
                                                                    {index !== 0 &&
                                                                        <DeleteAction className='pointer padd-left' deleteMessage1={deleteMessage1} deleteMessage2={deleteMessage2} deleteLabel={deleteLabel} Day={day}
                                                                            triggerdelete={() => handleDeleteWorkLocation(day, index)} />
                                                                        //  <FontAwesomeIcon className='pointer padd-left' icon={faTrashCan} onClick={() => handleDeleteWorkLocation(day, index)} />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )) : []
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 headers_dark mandatory' : 'p-0 headers mandatory'}>{t('PrivacyAndVisibility')}</h5></div>
                                        <div className="row mb-3 work-location">
                                            <div className='col-9'>
                                                <span className='days-full'>{t('MakeMyWorkLocationInformationVisibleTo')}</span>
                                            </div>
                                            <div className='col-3 pl-0'>
                                                <WorkViewDropdown value={getSettingsData.data?.WorkPlaceVisibility} onOptionSelect={(event: SelectionEvents, data: OptionOnSelectData) =>
                                                    workInformationselct(data)}  {...register("WorkPlaceVisibility", {
                                                        required: true,
                                                    })} />
                                                {errors.WorkPlaceVisibility && errors.WorkPlaceVisibility.type === "required" && (
                                                    <span className="errorText mt-2 px-2" style={{ textWrap: "nowrap" }}> {t('PleaseSelectAnyWorkPlaceVisibility')}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row mb-3 work-location">
                                            {/* <div className='col-12'>
                                                {getSettingsData.data?.WorkPlaceVisibility && <Image className='days' src={Commondata.folderName + "alert yellow.svg"} />}
                                                <span className='days mt-1'></span>

                                            </div> */}
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                {getSettingsData.data?.WorkPlaceVisibility && <span className="days mt-1">{workInformation}
                                                    <span> <Image className='alerticon px-2' src={Commondata.folderName + "/alert yellow.svg"} /></span> </span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 headers_dark' : 'p-0 headers'}>{t('TeamsAndDepartments')}</h5></div>
                                <div className="row mb-3 px-1">
                                    <div className="col-md-6">
                                        <label className={theme === 'dark' ? 'label-head_dark lock-icon' : 'label-head lock-icon'}><Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`}
                                        />
                                            <span className='mar-left'>{t('Team')}</span></label>
                                        {/* <input className="inputBox" type="text" readOnly={true} {...register("team", {
                                            required: true,
                                        })} /> */}
                                        {getSettingsData.MysettingsBasicdata[0].Teams?.length > 0 ? getSettingsData.MysettingsBasicdata[0].Teams?.map((team: { Name: string }, index: number) => (
                                            <div className="col-md-12" key={index}>
                                                <input className={theme === 'dark' ? 'inputBox_Darker locked_dark ' : "inputBox locked"} style={{ background: "#313131;" }} type="text" value={team.Name} readOnly={true} />
                                            </div>
                                        )) : <h6 className='mt-3'>{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>
                                        }

                                    </div>
                                    <div className="col-md-6">
                                        <label className={theme === 'dark' ? 'label-head_dark lock-icon' : 'label-head lock-icon'}><Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`}
                                        />
                                            <span className='mar-left'>{t('Department')}</span></label>
                                        {/* <input className="inputBox" type="text" readOnly={true} {...register("department", {
                                            required: true,
                                        })} /> */}
                                        {getSettingsData.data.Departments?.length > 0 ? getSettingsData.data.Departments.map((team: { Name: string }, index: number) => (
                                            <div className="col-md-12" key={index}>
                                                <input className={theme === 'dark' ? 'inputBox_Darker locked_dark' : "inputBox locked "} style={{ background: "#313131;" }} type="text" value={team.Name} readOnly={true} />
                                            </div>
                                        )) : <h6 className='mt-3'>{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>
                                        }

                                    </div>
                                </div>
                                <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 headers_dark' : 'p-0 headers'}>{t('CustomOptions')}</h5></div>
                                <div className="row mb-3 px-1">
                                    <div className="col-lg-4 col-xl-4 col-md-5 format_dropdown ">
                                        <label className={theme === 'dark' ? 'label-head_dark mandatory' : 'label-head mandatory'}>{t('DateFormat')}</label>
                                        <Dateformat value={dateFormat?.toString()}  {...register("DateFormat", {
                                            required: true,
                                        })} onOptionSelect={(event: SelectionEvents, data: OptionOnSelectData) =>
                                            DateformatSelect(data)} style={{ whiteSpace: "nowrap" }} />
                                        {errors.DateFormat && errors.DateFormat.type === "required" && (
                                            <span className="errorText mt-2 px-2"> {t('PleaseSelectAnyDateFormat')}</span>
                                        )}
                                    </div>
                                    <div className="col-lg-4 col-xl-4 col-md-5 timeformat">
                                        <label style={{ textWrap: "nowrap" }} className={theme === 'dark' ? 'label-head_dark mandatory' : 'label-head mandatory'}>{t('TimeFormat')}</label>
                                        <Timeformat value={timeformat} onOptionSelect={(event: SelectionEvents, data: OptionOnSelectData) =>
                                            TimeformatSelect(data)}  {...register("timeformat", {
                                                required: true,
                                            })} style={{ whiteSpace: "nowrap" }} />
                                        {errors.timeformat && errors.timeformat.type === "required" && (
                                            <span className="errorText mt-2 px-2 "> {t('PleaseSelectAnyTimeFormat')}</span>
                                        )}
                                    </div>
                                    <div className="col-lg-4 col-xl-4 col-md-2">
                                        <label className={theme === 'dark' ? 'label-head_dark mandatory' : 'label-head mandatory'} style={{ whiteSpace: "nowrap" }}>{t('FirstDayOfTheWeek')}</label>
                                        <WeekDropdown value={dayOfWeek} {...register("FirstDayOfWeek", {
                                            required: true,
                                        })} onOptionSelect={(event: SelectionEvents, data: OptionOnSelectData) =>
                                            DaySelect(data)} />
                                        {errors.FirstDayOfWeek && errors.FirstDayOfWeek.type === "required" && (
                                            <span className="errorText mt-2 px-2"> {t('PleaseSelectFirstDayOfTheWeek')}</span>
                                        )}
                                    </div>
                                </div>
                                <div className='row mb-2 mt-3'><h5 className={theme === 'dark' ? 'p-0 headers_dark' : 'p-0 headers'}>{t('AccessSettings')}</h5></div>
                                <div className="row mb-3 px-1">
                                    <div className="col-md-12">
                                        <label className={theme === 'dark' ? 'label-head_dark lock-icon' : 'label-head lock-icon'}>
                                            <Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`}
                                            />
                                            <span className='mar-left'>{t('BookableLocations')}</span>
                                        </label>
                                    </div>
                                    {!getSettingsData.data.BookableLocations || getSettingsData.data.BookableLocations.length === 0 ? (
                                        <h6 className='mt-3'>{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>
                                    ) : (
                                        BookableLocations.map((formattedLocation: any, index: number) => (
                                            <div className="col-md-12" key={index}>
                                                <input
                                                    className={theme === 'dark' ? 'inputBox_Darker locked_dark' : 'inputBox locked'}
                                                    type="text"
                                                    value={formattedLocation}
                                                    readOnly
                                                />
                                            </div>
                                        ))
                                    )}

                                </div>
                                {/* <div className='row mb-2 mt-3'><h5 className=theme ==='dark' ? 'p-0 headers_dark' :'p-0 headers'>Access settings</h5></div> */}
                                <div className="row mb-3 px-1">
                                    <div className="col-md-12">
                                        <label className={theme === 'dark' ? 'label-head_dark lock-icon' : 'label-head lock-icon'}>
                                            <Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`}
                                            />
                                            <span className='mar-left'>{t('ViewOnlyLocations')}</span>
                                        </label>
                                    </div>
                                    {!getSettingsData.data.ViewableLocations || getSettingsData.data.ViewableLocations.length === 0 ? (
                                        <h6 className='mt-3'>{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>
                                    ) : (
                                        ViewonlyLocations.map((formattedLocation: any, index: number) => (
                                            <div className="col-md-12" key={index}>
                                                <input
                                                    className={theme === 'dark' ? 'inputBox_Darker locked_dark' : "inputBox locked"}
                                                    type="text"
                                                    value={formattedLocation}
                                                    readOnly
                                                />
                                            </div>
                                        ))
                                    )}

                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    );
};

export default MySettings
